export function isStandalonePWA(): boolean {
  // iOS uses navigator.standalone, others use display-mode media query
  const isIOSStandalone = (navigator as any).standalone === true;
  const isDisplayModeStandalone = window.matchMedia && window.matchMedia('(display-mode: standalone)').matches;
  return isIOSStandalone || isDisplayModeStandalone;
}
